<template>
    <div class="do-task-form-component">
        <div class="task-body">
            <b-form data-vv-scope="do-task-form">
                <b-form-group
                    v-if="taskIsFile==1"
                    label="Soal"
                    label-for="soal"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <div v-if="taskFileType=='video'">
                        <video-embed :src="taskFilePath"></video-embed>
                    </div>
                    <div v-else style="text-align:center">
                        <iframe :src="taskViewList" width="100%" height="500"></iframe>
                    </div>
                </b-form-group>
                <b-form-group
                    v-if="taskIsFile==0"
                    label="Soal"
                    label-for="soal"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <p v-html="taskQuestion"></p>
                </b-form-group>
                <b-form-group
                    label="Jawaban"
                    label-for="jawaban"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <wysiwyg
                        id="answer"
                        name="answer"
                        data-vv-as="Jawaban"
                        v-model="do_task_form.answer"
                        type="text"
                        v-validate="'required'"
                        autocomplete="off"
                    />
                    <span :class="{ 'error-validation': errors.first('do-task-form.answer') }">{{ errors.first('do-task-form.answer') }}</span>
                </b-form-group>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideDoTaskFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveDoTask">SIMPAN</b-button>
        </div>
    </div>
</template>
<script>
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    import { EventBus } from '@/eventBus.js'
    export default {
        props: {
            modulId: {
                type: String,
                default: null
            },
            taskId: {
                type: String,
                default: null
            },
            duration: {
                type: [String, Number],
                default: 0
            },
            taskQuestion: {
                type: String,
                default: null
            },
            taskIsFile: {
                type: [String, Number],
                default: 0
            },
            taskFilePath: {
                type: String,
                default: '-'
            },
            taskFileType: {
                type: String,
                default: 'text'
            },
            taskViewList: {
                type: String,
                default: ''
            }
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                do_task_form: {
                    task_id: this.taskId,
                    answer: null,
                    duration: this.duration
                }
            };
        },
        methods: {
            resetDoTaskForm() {
                this.do_task_form.answer = null
                this.$validator.reset()
            },
            hideDoTaskFormModal() {
                EventBus.$emit('hideDoTaskFormModal', true)
                this.resetDoTaskForm()
            },
            async saveDoTask() {
                let scope = 'do-task-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.doingTask(scope)
                    }
                });
            },
            async doingTask(scope) {
                this.showLoader = true
                let form = this.do_task_form
                this.$store.dispatch('doingTask', form)
                    .then((res) => {
                        this.showLoader = false
                        let modulId = this.modulId
                        this.$store.dispatch('getTaskOverview', { modulId })
                        this.hideDoTaskFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            },
        },
        created() {
			EventBus.$on('resetDoTaskForm', (val) => {
				if (val) {
					this.resetDoTaskForm()
				}
			})
        }
    }
</script>